export default __webpack_public_path__ + "static/media/netflix.6607f1d3.webp";